export const GET_BILLING_DATA = 'billing/GET_BILLING_DATA';
export const GET_BILLING_DATA_SUCCESS = 'billing/GET_BILLING_DATA_SUCCESS';
export const GET_BILLING_DATA_FAIL = 'billing/GET_BILLING_DATA_FAIL';



// WEBPACK FOOTER //
// ./src/redux/constants/billing.js